import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize20 {
  size?: '20';
}
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize20 | OverrideIconSize24;

const SvgComponent = ({
  size = '20',
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '20') {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.41768 2.14012C9.73193 1.97714 10.1133 1.95677 10.4388 2.07676L10.5746 2.13677L17.4289 5.5641C18.1498 5.93529 18.1878 6.83914 17.5429 7.26485L17.4291 7.3312L15.9059 8.11641L17.439 8.92611C18.1472 9.31131 18.1845 10.2242 17.551 10.6634L17.4392 10.732L15.6804 11.6896L17.4289 12.5639C18.1497 12.935 18.1876 13.8375 17.5429 14.2644L17.4291 14.331L10.5804 17.8614C10.2676 18.0231 9.88742 18.0433 9.55697 17.9222L9.41873 17.8616L2.56944 14.3309C1.85007 13.9596 1.81221 13.0578 2.4607 12.6283L2.57514 12.5612L4.31839 11.6896L2.56033 10.7323C1.8134 10.3269 1.8134 9.33308 2.56534 8.92323L4.09296 8.11642L2.57029 7.3315C1.85005 6.96141 1.81214 6.05827 2.45589 5.63096L2.5695 5.56432L2.80598 6.02386L2.57519 5.56143L9.41768 2.14012ZM5.17655 8.675L3.03815 9.80434L3.02526 9.81127C2.99818 9.82572 2.99296 9.82851 3.00953 9.83839L9.88664 13.5828C9.93589 13.6096 10.0014 13.6163 10.0585 13.603L10.1119 13.583L16.962 9.85324L16.9773 9.84509C17.002 9.83215 17.0066 9.82975 16.9922 9.82128L14.8223 8.67499L10.5805 10.8616C10.2676 11.0233 9.88748 11.0435 9.55703 10.9224L9.41879 10.8618L5.17655 8.675ZM10.12 3.02739C10.0681 3.00039 9.99746 2.99364 9.93297 3.00873L9.87146 3.03116L3.03695 6.44685L9.87658 9.9728C9.92983 10.0002 10.0016 10.007 10.0638 9.99343L10.1219 9.97299L16.9606 6.44785L10.12 3.02739ZM10.5905 14.461L14.6101 12.2724L16.9605 13.4467L10.1218 16.9728L10.0638 16.9932C10.0016 17.0068 9.9298 17 9.87655 16.9726L3.03791 13.4477L5.38876 12.2724L9.40882 14.4612L9.53328 14.5199C9.8728 14.6566 10.268 14.6371 10.5905 14.461Z"
          fill={color}
        />
      </svg>
    );
  }
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.3449 3.15764C11.6984 2.97428 12.1274 2.95136 12.4937 3.08635L12.6464 3.15386L20.3575 7.00962C21.1686 7.4272 21.2113 8.44404 20.4858 8.92296L20.3578 8.9976L18.6441 9.88097L20.3688 10.7919C21.1656 11.2252 21.2076 12.2523 20.4948 12.7463L20.369 12.8235L18.3905 13.9008L20.3575 14.8844C21.1684 15.3019 21.2111 16.3171 20.4857 16.7975L20.3577 16.8724L12.653 20.8441C12.301 21.0259 11.8734 21.0487 11.5016 20.9124L11.3461 20.8443L3.64064 16.8723C2.83136 16.4546 2.78876 15.4401 3.51831 14.9568L3.64705 14.8814L5.60818 13.9008L3.63035 12.8239C2.79005 12.3678 2.79005 11.2497 3.63597 10.7886L5.35457 9.88096L3.64158 8.99794C2.83131 8.58159 2.78866 7.56556 3.51288 7.08483L3.64068 7.00986L3.90672 7.52684L3.64709 7.00661L11.3449 3.15764ZM6.5736 10.5094L4.16788 11.7799L4.15338 11.7877C4.12292 11.8039 4.11705 11.8071 4.13569 11.8182L11.8724 16.0307C11.9278 16.0608 12.0016 16.0683 12.0658 16.0533L12.1259 16.0309L19.8322 11.8349L19.8495 11.8257C19.8772 11.8112 19.8823 11.8085 19.8662 11.7989L17.4251 10.5094L12.6531 12.9693C12.3011 13.1512 11.8734 13.1739 11.5017 13.0377L11.3461 12.9695L6.5736 10.5094ZM12.1349 4.15582C12.0766 4.12544 11.9971 4.11785 11.9246 4.13483L11.8554 4.16006L4.16654 8.0027L11.8611 11.9694C11.921 12.0002 12.0018 12.0079 12.0718 11.9926L12.1371 11.9696L19.8306 8.00383L12.1349 4.15582ZM12.6643 17.0186L17.1864 14.5564L19.8306 15.8775L12.1371 19.8444L12.0718 19.8674C12.0018 19.8827 11.921 19.875 11.8611 19.8442L4.16767 15.8786L6.81235 14.5564L11.3349 17.0189L11.4749 17.0848C11.8569 17.2387 12.3014 17.2167 12.6643 17.0186Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 20, 24 입니다.
 *
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'stack');
export default IconComponent;
